(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7475],{

/***/ 27475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BlogTrending": function() { return /* binding */ BlogTrending; },
  "default": function() { return /* binding */ blog_trending; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/skeleton/tranding_blog.jsx



var TrandingGrid = function TrandingGrid() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
    container: true,
    spacing: 2,
    alignItems: "center",
    children: [1, 2, 3, 4, 5].map(function (item, i) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        sm: 12,
        md: 3,
        lg: 2,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "rectangular",
          width: "100%",
          height: 150
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "rectangular",
          width: "100%",
          height: 20,
          sx: {
            margin: "10px 0px 20px 0px"
          }
        })]
      }, i);
    })
  });
};
/* harmony default export */ var tranding_blog = (TrandingGrid);
// EXTERNAL MODULE: ./_redux/blog/blogApi/blogApi.js
var blogApi = __webpack_require__(93152);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./_modules/study/blog/components/blog_category_box/blog_trending_box.module.scss
var blog_trending_box_module = __webpack_require__(30790);
var blog_trending_box_module_default = /*#__PURE__*/__webpack_require__.n(blog_trending_box_module);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./_modules/study/blog/components/blog_category_box/index.jsx








var CategoryBox = function CategoryBox(_ref) {
  var post = _ref.post;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat((blog_trending_box_module_default()).trending_box),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      legacyBehavior: true,
      href: "/blog/category/".concat(post === null || post === void 0 ? void 0 : post.slug),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (blog_trending_box_module_default()).image_wrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            layout: "fill",
            blurDataURL: (0,helpers/* getAssets */.Vh)("assets/images/study/country_placeholder.webp"),
            placeholder: "blur",
            src: (post === null || post === void 0 ? void 0 : post.featureImageSrc) || (0,helpers/* getAssets */.Vh)("/assets/images/image_placeholder_big.webp"),
            alt: post === null || post === void 0 ? void 0 : post.categoryName
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((blog_trending_box_module_default()).cat_title),
          children: post === null || post === void 0 ? void 0 : post.categoryName
        })]
      })
    })
  });
};

/* harmony default export */ var blog_category_box = (CategoryBox);
// EXTERNAL MODULE: ./_modules/study/blog/blog_home/blog_trending.module.scss
var blog_trending_module = __webpack_require__(45753);
var blog_trending_module_default = /*#__PURE__*/__webpack_require__.n(blog_trending_module);
;// CONCATENATED MODULE: ./_modules/study/blog/blog_home/blog_trending.jsx









var BlogTrending = function BlogTrending() {
  var _useGetTrandingBlogQu = (0,blogApi/* useGetTrandingBlogQuery */.Dz)(),
      data = _useGetTrandingBlogQu.data,
      loading = _useGetTrandingBlogQu.isLoading;

  var _useState = (0,react.useState)([]),
      posts = _useState[0],
      setPosts = _useState[1];

  var _useState2 = (0,react.useState)(""),
      error = _useState2[0],
      setError = _useState2[1];

  (0,react.useEffect)(function () {
    setPosts(data === null || data === void 0 ? void 0 : data.data);
  }, [data]);
  var content;

  if (loading) {
    /*#__PURE__*/
    (0,jsx_runtime.jsx)(tranding_blog, {});
  }

  if (!loading && error) {
    content = {
      error: error
    };
  }

  if (!loading && !error) {
    content = /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
      children: (posts === null || posts === void 0 ? void 0 : posts.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (blog_trending_module_default()).tranding_topic_wrapper,
        children: [" ", posts === null || posts === void 0 ? void 0 : posts.slice(0, 6).map(function (post, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(blog_category_box, {
            post: post
          }, i);
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "Data not found"
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: (blog_trending_module_default()).section_trending,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (blog_trending_module_default()).small_background
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (blog_trending_module_default()).wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: (blog_trending_module_default()).sec_title,
            children: "Trending Topics"
          }), content]
        })
      })]
    })
  });
};
/* harmony default export */ var blog_trending = (BlogTrending);

/***/ }),

/***/ 45753:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"blog_trending___next__2aHrj","section_trending":"blog_trending_section_trending__XfGyF","small_background":"blog_trending_small_background__Ub0t7","wrapper":"blog_trending_wrapper__UOi1H","sec_title":"blog_trending_sec_title___dVpm","tranding_topic_wrapper":"blog_trending_tranding_topic_wrapper__f2OVl"};

/***/ }),

/***/ 30790:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"trending_box":"blog_trending_box_trending_box__tCAOs","image_wrapper":"blog_trending_box_image_wrapper__3HUKj","cat_title":"blog_trending_box_cat_title__ZB2ml"};

/***/ })

}]);